<template>
    <div class="advanced-chart">
        <Chart :options="tickerOptions.chartOptions" />
    </div>
</template>

<script setup>
import { reactive } from 'vue'
import { Chart } from 'vue-tradingview-widgets'
import { useEntityStore } from '@/stores'
import { formatTicker } from '@/lib/financial'

const entityStore = useEntityStore()

const tickerOptions = reactive({
    chartOptions: {
        allow_symbol_change: true,
        symbol: formatTicker(entityStore.entity.stock_exchange, entityStore.entity.stock_ticker),
        autosize: true,
        width: '100%',
        height: '500',
    },
})
</script>

<style lang="scss" scoped>
.advanced-chart {
    width: 100%;

    #tradingview-chart {
        height: 500px;
    }
}
</style>
